import React, { useState, useEffect } from 'react';
import { PaymentRequestButtonElement, useStripe, useElements } from '@stripe/react-stripe-js';
import StatusMessages, { useMessages } from './StatusMessages';
import { stripePaymentIntent, getGpayData } from '../../../api/fastcoinService';
import Loading from '../../../assets/loading.gif';
import { getURLBackToPanel } from '../../../context/brokersUrl';


const CheckoutButton = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [messages, addMessage] = useMessages();
    const [loading, setLoading] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    useEffect(() => {
        if (!stripe || !elements) {
            return;
        }

        const order_no = sessionStorage.getItem("order_no")
        setLoading(true)
        getGpayData(order_no).then((res) => {
            const pr = stripe.paymentRequest({
                country: res.country,
                currency: res.currency,
                total: {
                    label: 'Deposit- payeasy',
                    amount: res.amount,
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });

            // Check the availability of the Payment Request API.
            pr.canMakePayment().then(result => {
                if (result) {
                    setPaymentRequest(pr);
                } else {
                    addMessage(`Payment method is not available`);
                }
                setLoading(false)
            });

            pr.on('paymentmethod', async (e) => {
                console.log(e.walletName)
                const { error: backendError, clientSecret } = await stripePaymentIntent(sessionStorage.getItem("order_no"), e.walletName)

                if (backendError) {
                    addMessage(backendError.message);
                    return;
                }

                const {
                    error: stripeError,
                    paymentIntent,
                } = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: e.paymentMethod.id,
                }, { handleActions: false });

                if (stripeError) {
                    // Show error to your customer (e.g., insufficient funds)
                    addMessage(stripeError.message);
                    return;
                } else {
                    // Report to the browser that the confirmation was successful, prompting
                    // it to close the browser payment method collection interface.
                    e.complete('success');
                    // Check if the PaymentIntent requires any actions and if so let Stripe.js
                    // handle the flow. If using an API version older than "2019-02-11"
                    // instead check for: `paymentIntent.status === "requires_source_action"`.
                    if (paymentIntent.status === "requires_action") {
                        // Let Stripe.js handle the rest of the payment flow.
                        const { error } = await stripe.confirmCardPayment(clientSecret);
                        if (error) {
                            // The payment failed -- ask your customer for a new payment method.
                        } else {
                            // The payment has succeeded.
                        }
                    } else {
                        // The payment has succeeded.
                    }
                }


                // Show a success message to your customer
                // There's a risk of the customer closing the window before callback
                // execution. Set up a webhook or plugin to listen for the
                // payment_intent.succeeded event that handles any business critical
                // post-payment actions.
                setIsSuccess(true)
                addMessage(`Payment has been comopleted`);

                window.location.replace(getURLBackToPanel());
            });
        })


    }, [stripe, elements, addMessage]);

    return (
        <>
            {loading && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {isSuccess === false && paymentRequest && <div style={{marginTop:"30%"}}><PaymentRequestButtonElement options={{
                paymentRequest,
                style: {
                    paymentRequestButton: {
                        type: 'default',
                        // One of 'default', 'book', 'buy', or 'donate'
                        // Defaults to 'default'

                        theme: 'dark',
                        // One of 'dark', 'light', or 'light-outline'
                        // Defaults to 'dark'
                        height: '40px',
                        // Defaults to '40px'. The width is always '100%'.
                    },
                }
            }} style={{ width: "50%" }} /></div>}

            <StatusMessages messages={messages} />
        </>
    );
};
export default CheckoutButton;